var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128.499,
    viewBox: "0 0 128 128.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 64,
    fill: "#f0effa"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#babfdf",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    d: "M20617-4908.038v-1.885a15.54 15.54 0 0 1 8.107-13.656l15.377-8.388a4.558 4.558 0 0 0 2.371-4v-5.7a36.245 36.245 0 0 1-6.037-12.476 6.849 6.849 0 0 1-2.58-5.361v-6.9a6.861 6.861 0 0 1 1.727-4.524v-9.168a15.452 15.452 0 0 1 3.6-11.253c3.541-4.036 9.289-6.084 17.078-6.084s13.541 2.049 17.084 6.09a15.465 15.465 0 0 1 3.607 11.248v9.168a6.877 6.877 0 0 1 1.723 4.524v6.9a6.844 6.844 0 0 1-4.01 6.235 39.718 39.718 0 0 1-5.092 10c-.432.6-.848 1.154-1.242 1.638v5.83a4.543 4.543 0 0 0 2.516 4.077l16.471 8.232a15.473 15.473 0 0 1 8.6 13.905v2.107a63.705 63.705 0 0 1-38.541 13.479h-.912a63.723 63.723 0 0 1-39.847-14.038z",
    transform: "translate(-20593 5022)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfile);
export default __webpack_public_path__ + "static/media/default-profile.a107eb5a05ddf0dded5be6bb168280db.svg";
export { ForwardRef as ReactComponent };